import { CreateOrganizationForm } from '@/components/onboarding/CreateOrganizationForm';

export default function OnboardingOrgPage() {
  return (
    <div className='bg-slate-50 dark:bg-stone-950 flex min-h-svh flex-col items-center justify-center p-6 md:p-10'>
      <CreateOrganizationForm />
    </div>
  );
}
